import { render, staticRenderFns } from "./districtControllerList.vue?vue&type=template&id=d920be3e&"
import script from "./districtControllerList.vue?vue&type=script&lang=js&"
export * from "./districtControllerList.vue?vue&type=script&lang=js&"
import style0 from "./districtControllerList.vue?vue&type=style&index=0&id=d920be3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports